import { Children, useState } from "react";
import { AddIcon, ContractIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function ContractTemplates() {
  const [contractList, setContractList] = useState([
    "[Contract Template Title]",
    "[Contract Template Title]",
    "[Contract Template Title]",
    "[Contract Template Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Contracts</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            contractList.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/contract-template/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setContractList(() => [...contractList, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setContractList(() =>
                      contractList.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <ContractIcon />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
